import React from 'react'
import _ from 'lodash'

import {ImageThumb} from '../layout/imagethumb.component'
import {Rating} from '../layout/rating.component'

import {LunaModal} from '../lunamodal.component'
import {AccommodationsEntry} from '../../accommodations/accommodationentry.component'

export class RelatedAccommodation extends React.Component {
    constructor(props) {
        super(props)

        this._item = this.props.item

        this.state = {
            isAdded: false,
            showModal: false,
            statusModal: null
        }

        _.bindAll(this,
            'addToItin',
            'removeFromItin',
            'showDetails',
            'showModal',
            'onModalHide'
        )
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.leg.get('accommodations').size !== nextProps.leg.get('accommodations').size || this.state.isAdded !== nextState.isAdded) {
            return true
        } else {
            return false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let myIndex = this.props.leg.get('accommodations').findIndex((accom) => {
            return accom.get('id') === this._item.get('id')
        })
        if (myIndex >  -1) {
            if (!prevState.isAdded) {
                this.setState({isAdded: true})
            }
        } else {
            if (prevState.isAdded) {
                this.setState({isAdded: false})
            }
        }
    }

    addToItin() {
        this.setState({isAdded: true})
        if (this.props.addToItinFromOverview) {
            this.props.addToItinFromOverview(this._item)
        } else {
            this.props.addToItin(this._item) // TODO: Confirm this function passes down correctly, will need to vary by item type
        }
    }

    removeFromItin() {
        this.setState({isAdded: false})
        this.props.removeFromItin(this._item) // TODO: Confirm this function passes down correctly, will need to vary by item type
    }

    showDetails(accomm) {
        if (this.props.leg.getIn(['destination', 'id']) === -1 && this.props.onActivateAccommodationInOverview) {
            this.props.onActivateAccommodationInOverview(accomm)
        } else {
            this.props.onActivateAccommodation(accomm)
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.DETAILS)
        }
    }

    showModal() {
        this.setState({
            showModal: true,
            statusModal: null
        })
    }

    onModalHide() {
        this.setState({
            showModal: false
        })
    }

    modalContent() {
        return (
            <div className="modal-content">
                <i className="icon-close" onClick={this.onModalHide}/>
                <AccommodationsEntry {...this.props} item={this._item} onModalHide={this.onModalHide} isModal={true}/>
            </div>
        )
    }

    render() {
        // TODO: Image as img or bg?
        let addIcon = this.state.isAdded ? <i onClick={() => {this.removeFromItin()}} className="related-content-add icon-favorite_selected"/> : <i onClick={() => {this.addToItin()}} className="related-content-add icon-favorite"/>
        let showClass = this.props.showMe ? 'related-content-item accommodation' : 'hide related-content-item accommodation'
        let resIcon = this.state.isAdded ? <div onClick={() => {this.showModal()}} className="related-content-reservation"><span>RESERVE</span><i className="icon-reservation"/></div> : ''
        return (
            <div className={showClass}>
                <LunaModal statusModal={this.state.statusModal} onModalHide={this.onModalHide} showModal={this.state.showModal} modalContent={this.modalContent()}/>
                <div className="related-content-header">
                    <ImageThumb showDetails={this.showDetails} type="related-content" item={this._item}/>
                    {addIcon}
                    <h2 onClick={() => {this.showDetails(this._item)}}>{this._item.get('name')}</h2>
                    <span>{this._item.get('city')}</span>
                </div>
                <div className="related-content-details">
                    <Rating type="stars" itemCount={this._item.get('rating')}/>
                    <Rating type="startingPrice" itemCost={this._item.getIn(['price_range', 'low'])}/>
                </div>
                {resIcon}
            </div>
        )
    }
}
